export class PerkSlider {
  private items: NodeListOf<Element>;
  private currentIndex: number = 0;

  constructor(private container: Element) {
    this.items = container.querySelectorAll('[data-slider-item]');
    this.goTo(0);
    container.querySelector('[data-slider-prev]')?.addEventListener('click', () => this.prev());
    container.querySelector('[data-slider-next]')?.addEventListener('click', () => this.next());
  }

  goTo(index: number): void {
    const content = this.container.querySelector<HTMLElement>('[data-slider-content]');
    if (content) content.style.transform = `translateX(-${index * 100}%)`;
    this.currentIndex = index;
  }

  next(): void {
    this.goTo((this.currentIndex + 1) % this.items.length);
  }

  prev(): void {
    this.goTo((this.currentIndex - 1 + this.items.length) % this.items.length);
  }
}